import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useRef, useState } from 'react';

/**
 * The width an element is laid out at, followed as it changes.
 *
 * Measured before the first paint, so what is drawn from it never shows at a
 * wrong size. A width of nothing — the element hidden, as for print — keeps
 * the last one, so that the drawing comes back as it was.
 */
export const useElementWidth = () => {
  const $ = _c(4);
  const element = useRef(null);
  const [width, setWidth] = useState(0);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const measured = element.current;
      if (!measured) {
        return;
      }
      const measure = () => {
        const next = measured.getBoundingClientRect().width;
        if (next > 0) {
          setWidth(next);
        }
      };
      const observer = new ResizeObserver(measure);
      observer.observe(measured);
      measure();
      return () => {
        observer.disconnect();
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useLayoutEffect(t0, t1);
  let t2;
  if ($[2] !== width) {
    t2 = [element, width];
    $[2] = width;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2 as const;
};